// import React from 'react';

// import { AuthOutLet } from './authLayOut';

// import SignIn from '../components/Auth/SignIn';
// import Signup from '../components/Auth/Signup';
// import Page404 from '../components/Auth/Page404';
// import PasswordReset from '../components/Auth/PasswordReset';
// import StepAuthentication from '../components/Auth/StepAuthentication';

// export const publicRoutes = [
//   {
//     path: '/auth',
//     element: <AuthOutLet />,
//     children: [
//       { path: '', element: <SignIn /> },
//       { path: 'sign-up', element: <Signup /> },
//       { path: 'password-reset', element: <PasswordReset /> },
//       { path: '2-step-authentication', element: <StepAuthentication /> },
//       { path: '*', element: <Page404 /> }
//     ]
//   }
// ];

import React from 'react';

// import { AuthOutLet } from './authLayOut';

import SignIn from '../components/Auth/SignIn';
import Signup from '../components/Auth/Signup';
import Page404 from '../components/Auth/Page404';
import PasswordReset from '../components/Auth/PasswordReset';
import StepAuthentication from '../components/Auth/StepAuthentication';

export const publicRoutes = [
  { path: '/', element: <SignIn /> },
  { path: '/auth', element: <SignIn /> },
  { path: '/auth/sign-up', element: <Signup /> },
  { path: '/auth/password-reset', element: <PasswordReset /> },
  { path: '/auth/2-step-authentication', element: <StepAuthentication /> },
  { path: '/auth/*', element: <Page404 /> }
];
